import {
  ADD_RECORD,
  DELETE_RECORD,
  SELECT_RECORD,
  UPDATE_RECORD,
  CLEAR_ALL_RECORDS,
  INIT_SELECT_RECORD,
  RESET_STORE,
  ADD_SINGLE_RECORD,
  ADD_ARRAY
} from "../actions/actionTypes";
import _ from "lodash";
//static initial data
import { tUsers } from "../../staticData/tUsers";
import { tListOfTables } from "../../staticData/tListOfTables";
import { tCreateTable } from "../../staticData/tCreateTable";
import { tMenuDesigner } from "../../staticData/tMenuDesigner";
import { tSupplierShopItems } from "../../staticData/tSupplierShopItems";
import { tPopularItems } from "../../staticData/tPopularItems";

let groupedProds = _.chain(tSupplierShopItems)
  .groupBy("category")
  .value();
//console.log(JSON.stringify(groupedProds));

const initialState = {
  users: tUsers,
  listOfTables: tListOfTables,
  createTable: tCreateTable,
  menuDesigner: tMenuDesigner,
  supplierShopItems: tSupplierShopItems,
  ...groupedProds,
  POPULAR: tPopularItems
};

const dbReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_RECORD:
      if (state[action.path]) {
        let newArray = [...state[action.path]];
        newArray = newArray.concat({
          ...action.payload,
          key: action.key
        });

        let newAddState = { ...state };
        newAddState[action.path] = newArray;
        return newAddState;
      } else {
        let newState = { ...state };

        newState[action.path] = [];
        newState[action.path].push({
          key: action.key,
          ...action.payload
        });

        return newState;
      }

    case ADD_ARRAY:
      let newArrayState = { ...state };
      newArrayState[action.path] = action.payload;
      return newArrayState;

    case UPDATE_RECORD:
      let newArray = [...state[action.path]];
      newArray = newArray.map((record, index) => {
        if (record.key === action.payload.key) {
          return action.payload;
        }
        return record;
      });
      let newUpdateState = { ...state };
      newUpdateState[action.path] = newArray;
      newUpdateState["selected" + action.path] = action.payload;
      return newUpdateState;

    case DELETE_RECORD:
      newArray = [...state[action.path]];
      newArray = newArray.filter(item => {
        return item.key !== action.payload.key;
      });

      let newDelState = { ...state };
      newDelState[action.path] = newArray;
      return newDelState;

    case CLEAR_ALL_RECORDS:
      let newClearState = { ...state };
      newClearState[action.path] = [];
      return newClearState;

    case SELECT_RECORD:
      let newSelectState = { ...state };
      newSelectState["selected" + action.path] = state[action.path].find(
        data => {
          return data.key === action.key;
        }
      );

      return newSelectState;

    case ADD_SINGLE_RECORD:
      let newAddSingleState = _.cloneDeep(state);

      newAddSingleState[action.path] = action.payload;

      return newAddSingleState;

    case INIT_SELECT_RECORD:
      let newInitState = { ...state };
      newInitState["selected" + action.path] = { ...action.data };
      return newInitState;

    case RESET_STORE:
      return initialState;
    default:
      return state;
  }
};

export default dbReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/db.js